module.exports = __webpack_public_path__ + "static/media/security.07af6c06.svg";